import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleService } from '../../../services/role.service';
import { UserRole } from '../../../shared/types/role.interface';

/**
 * A presentational component that displays a "no packages" state and provides a control to add a new package.
 * @component
 * @selector app-no-packages
 * @example
 *   <app-no-packages (addPackage)="onAddPackage()"></app-no-packages>
 * @input None - This component does not accept any input properties.
 * @output {EventEmitter<void>} addPackage - Emitted when the user requests adding a new package (e.g., clicking an "Add package" button).
 * @method onAddPackage(): void - Invoked by the template; emits the addPackage event to notify parent components.
 * @method isAdmin(): boolean - Utility method that returns true if the current user has the ADMIN role; delegates to the injected RoleService.
 * @constructor - Injects RoleService (public) to allow template binding and role checks.
 * @lifecycle None - This component does not implement Angular lifecycle hooks (ngOnInit, ngOnDestroy, etc.); any initialization is handled in the constructor or via services.
 */
@Component({
  selector: 'app-no-packages',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './no-packages.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./no-packages.component.scss'],
})
export class NoPackagesComponent {
  @Output() addPackage = new EventEmitter<void>();

  constructor(public roleService: RoleService) {}

  onAddPackage(): void {
    this.addPackage.emit();
  }

  isAdmin(): boolean {
    return this.roleService.getCurrentUserRole() === UserRole.ADMIN;
  }
}
